import { z } from "zod";
import { addressSchema } from "./IAddress"; // Zod-Schema für IAddress

export const companySchema = z.object({
    id: z.number(),
    company_name: z.string(),
    Address: addressSchema,
    tax_id: z.string(),
    vat_id: z.string(),
    homepage: z.string(),
    telefon: z.string(),
    email: z.string(),
});

export type ICompany = z.infer<typeof companySchema>;